import React from 'react';
import { PlmEventResponseDetailForm } from './plmEventResponse-detail-form';

export const PlmEventResponseEdit: React.FC = () => {
  return <PlmEventResponseDetailForm />;
};
